/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 * Based a little on X3DOM JavaScript Library States.js file
 */

export default
class StateViewer {
    private viewer: HTMLDivElement;
    private measureList: HTMLUListElement;
    private measurements: any = {};
    private checkboxes: any = {};
    private labels: any = {};
    private sections: any = {};

    constructor() {
        this.viewer = document.createElement('div');
        this.viewer.id = 'cwEngine-state-viewer';
        this.viewer.style.display = 'none';

        let title = document.createElement('div');
        title.className = 'cwEngine-states-head';

        let subTitle = document.createElement('span');
        subTitle.className = 'cwEngine-states-head2';
        title.appendChild(subTitle);

        this.measureList = document.createElement('ul');
        this.measureList.className = 'cwEngine-states-list';

        this.viewer.appendChild(title);
        this.viewer.appendChild(this.measureList);

        this.viewer.addEventListener("contextmenu", this.disableContextMenu);
    }

    /**
     * Disable the context menu
     */
    private disableContextMenu(e: Event): boolean {
        e.preventDefault();
        e.stopPropagation();
        e.returnValue = false;
        return false;
    };

    /**
     * Add a seperator for thousands to the string
     */
    public thousandSeperator(value: number): string {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    /**
     * Return numerical value to fixed length
     */
    public toFixed(value: number): string {
        let fixed = (value < 1) ? 2 : (value < 10) ? 2 : 2;
        return value.toFixed(fixed);
    };

    public show(aVisible): void
    {
        this.viewer.style.display = aVisible ? "block" : "none";
    }

    public toggle(): void {
        this.viewer.style.display = this.viewer.style.display !== 'none' ? "none" : "block";
    }

    public isActive(): boolean
    {
        return this.viewer.style.display !== 'none';
    }

    public addSection(aTitle: string): void
    {
        if (this.sections[aTitle] === undefined) {
            let infoItem = document.createElement('li');
            infoItem.className = 'cwEngine-states-head'; // cwEngine-states-item

            let infoTitle = document.createElement('div');
            infoTitle.className = 'cwEngine-states-item-title';
            infoTitle.appendChild(document.createTextNode(aTitle));

            infoItem.appendChild(infoTitle);
            this.measureList.appendChild(infoItem);

            this.sections[aTitle] = "";
        }
    }

    public addFixedMeasurement = function(aTitle: string, aValue: number): void
    {
        this.addMeasurement(aTitle, aValue, true);
    }

    public addMeasurement(aTitle: string, aValue: number, aFixed: boolean)
    {
        // add new measurement type to the measurements list
        if (this.measurements[aTitle] === undefined) {
            let infoItem = document.createElement('li');
            infoItem.className = 'cwEngine-states-item';

            let infoTitle = document.createElement('div');
            infoTitle.className = 'cwEngine-states-item-title';
            infoTitle.appendChild(document.createTextNode(aTitle));

            let infoValue = document.createElement('div');
            infoValue.className = 'cwEngine-states-item-value';
            infoValue.appendChild(document.createTextNode(aFixed ? this.toFixed(aValue) : "" + aValue));

            infoItem.appendChild(infoTitle);
            infoItem.appendChild(infoValue);

            this.measureList.appendChild(infoItem);

            this.measurements[aTitle] = infoValue;
        }

        this.measurements[aTitle].firstChild.nodeValue = aFixed ? this.toFixed(aValue) : aValue;
    }

    public addCheckBox(aTitle: string, onClickCB: (any) => void): void
    {
        // add new measurement type to the measurements list
        if (this.checkboxes[aTitle] === undefined) {
            let infoItem = document.createElement('li');
            infoItem.className = 'cwEngine-states-item';

            let infoTitle = document.createElement('div');
            infoTitle.className = 'cwEngine-states-item-title';
            infoTitle.appendChild(document.createTextNode(aTitle));

            let infoValue = document.createElement('input');
            infoValue.className = 'cwEngine-states-item-value';
            infoValue.type = "checkbox";
            infoValue.name = aTitle;
            infoValue.id = aTitle;
            infoValue.onclick = function(aCheckboxDOMElement) {
                let checkBox = aCheckboxDOMElement;
                return function() {
                    onClickCB(checkBox);
                };
            }(infoValue);

            infoItem.appendChild(infoTitle);
            infoItem.appendChild(infoValue);

            this.measureList.appendChild(infoItem);

            this.checkboxes[aTitle] = infoItem;
        }
    }

    public static getLDTexturesColorLabels(): any
    {
        return {
            "256": "#ff19ff",
            "512": "#ff0000",
            "1024": "#00ff00",
            "2048": "#0000ff"
        }
    }

    public static getGeometryLODColorLabels = function()
    {
        return {
            "0": "#ffff00",
            "1": "#aaffee",
            "2": "#ff19ff",
            "3": "#ff0000",
            "4": "#00ff00",
            "5": "#0000ff"
        }
    }

    public addLDTexturesLabel(): void
    {
        // add new measurement type to the measurements list
        if (this.labels.LDTexturesColorLabels === undefined) {
            var infoItem = document.createElement('li');
            infoItem.className = 'cwEngine-states-item';

            var ldTexColors = StateViewer.getLDTexturesColorLabels();

            var infoTitle = document.createElement('span');
            //infoTitle.className = 'cwEngine-states-item-title';
            infoTitle.appendChild(document.createTextNode("#256  "));
            infoTitle.style.cssText = "font-weight: bold;color: " + ldTexColors["256"] + "; background-color: white;";
            infoItem.appendChild(infoTitle);

            infoTitle = document.createElement('span');
            //infoTitle.className = 'cwEngine-states-item-title';
            infoTitle.appendChild(document.createTextNode("#512  "));
            infoTitle.style.cssText = "font-weight: bold;color: " + ldTexColors["512"] + "; background-color: white;";
            infoItem.appendChild(infoTitle);

            infoTitle = document.createElement('span');
            //infoTitle.className = 'cwEngine-states-item-title';
            infoTitle.appendChild(document.createTextNode("#1024  "));
            infoTitle.style.cssText = "font-weight: bold;color: " + ldTexColors["1024"] + "; background-color: white;";
            infoItem.appendChild(infoTitle);

            infoTitle = document.createElement('span');
            //infoTitle.className = 'cwEngine-states-item-title';
            infoTitle.appendChild(document.createTextNode("#2048  "));
            infoTitle.style.cssText = "font-weight: bold;color: " + ldTexColors["2048"] + "; background-color: white;";
            infoItem.appendChild(infoTitle);

            this.measureList.appendChild(infoItem);

            this.labels.LDTexturesColorLabels = infoItem;
        }
    }

    public addGLODLabel(): void
    {
        // add new measurement type to the measurements list
        if (this.labels.GLODColorLabels === undefined) {
            var infoItem = document.createElement('li');
            infoItem.className = 'cwEngine-states-item';

            var glodColors = StateViewer.getGeometryLODColorLabels();

            var infoTitle = document.createElement('span');
            //infoTitle.className = 'cwEngine-states-item-title';
            infoTitle.appendChild(document.createTextNode("#0  "));
            infoTitle.style.cssText = "font-weight: bold;color: " + glodColors["0"] + "; background-color: white;";
            infoItem.appendChild(infoTitle);

            infoTitle = document.createElement('span');
            //infoTitle.className = 'cwEngine-states-item-title';
            infoTitle.appendChild(document.createTextNode("#1  "));
            infoTitle.style.cssText = "font-weight: bold;color: " + glodColors["1"] + "; background-color: white;";
            infoItem.appendChild(infoTitle);

            infoTitle = document.createElement('span');
            //infoTitle.className = 'cwEngine-states-item-title';
            infoTitle.appendChild(document.createTextNode("#2  "));
            infoTitle.style.cssText = "font-weight: bold;color: " + glodColors["2"] + "; background-color: white;";
            infoItem.appendChild(infoTitle);

            infoTitle = document.createElement('span');
            //infoTitle.className = 'cwEngine-states-item-title';
            infoTitle.appendChild(document.createTextNode("#3  "));
            infoTitle.style.cssText = "font-weight: bold;color: " + glodColors["3"] + "; background-color: white;";
            infoItem.appendChild(infoTitle);

            infoTitle = document.createElement('span');
            //infoTitle.className = 'cwEngine-states-item-title';
            infoTitle.appendChild(document.createTextNode("#4  "));
            infoTitle.style.cssText = "font-weight: bold;color: " + glodColors["4"] + "; background-color: white;";
            infoItem.appendChild(infoTitle);

            infoTitle = document.createElement('span');
            //infoTitle.className = 'cwEngine-states-item-title';
            infoTitle.appendChild(document.createTextNode("#5  "));
            infoTitle.style.cssText = "font-weight: bold;color: " + glodColors["5"] + "; background-color: white;";
            infoItem.appendChild(infoTitle);

            this.measureList.appendChild(infoItem);

            this.labels.GLODColorLabels = infoItem;
        }
    }
}
